<mat-card [class.Selected]="isSelected" [class.Unavailable]="!isAvailable">
  <mat-card-content>
    <button (click)="designClick.emit(design)" mat-flat-button>
      <div [class.Selected]="isSelected" class="Flexbox Flexbox--column Gap--smaller ButtonContent">
        <div class="ImageContainer">
          <img [src]="getThumbnail(design)" loading="lazy" decoding="async">
        </div>
        <div class="Flexbox ButtonName">
          <span>
            @if (design) {
              {{ design.displayName }}
            } @else {
              Plain
            }
          </span>
        <!-- <app-selection-indicator [isVisible]="isSelected" [shouldAnimate]="shouldAnimateSelection" [isUnavailable]="!isAvailable"></app-selection-indicator> -->
        </div>
      </div>
    </button>
  </mat-card-content>
</mat-card>